// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WizardServicos_CancelaServicoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /wizard_servicos/cancela_servico/{compromissoServicoId}/{orcamentoServicoId}
 *
 * Cancels a service item. No body required — both IDs are URL path parameters.
 */
import { registerContract } from './validate'

export interface WizardServicos_CancelaServicoInput {}

registerContract('WizardServicos_CancelaServicoInput', {})
